import React, { useEffect } from 'react';
import { LandingHeaderB2B } from './LandingHeaderB2B';
import { Footer } from '../footer/Footer';

const landingImages = require.context('../../assets/images', true);

export const LandingThanksPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <LandingHeaderB2B />
      <div className="container-fluid landing__ThanksSection">
        <div className="container my-5 py-5 py-sm-2">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-lg-6 text-center pe-0 mb-3">
              <img
                alt="¡GRACIAS POR TU INTERÉS EN “YO EMPRENDO”!"
                src={landingImages('./gracias.png')}
                className="img-fluid"
                width="400"
                height="80%"
              />
            </div>
            <div className="col-xl-6 col-lg-6 col-md-10 col-12">
              <div className="row">
                <div className="col-12 text-center mb-3 mt-2">
                  <img alt="Gracias" src={landingImages('./corazon.png')} width="80" height="60" />
                </div>
              </div>
              <div className="row">
                <div className="col-12 landingb2b__title-thanks">
                  ¡GRACIAS POR
                  <br />
                  TU INTERÉS EN
                  <br />
                  “YO EMPRENDO”!
                </div>
              </div>
              <div className="row my-2">
                <div className="col-12 landingb2b__paragraph-text-thanks mb-2">
                  Muy pronto nos comunicaremos contigo. Mientras tanto, si tienes preguntas,
                  <br />
                  <span className="fw-bold">¡no dudes en contactarnos!</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
